import { UntypedFormGroup } from '@angular/forms';

export function ConfirmedValidator(controlName: string, matchingControlName: string): (formGroup: UntypedFormGroup) => void {
  return (formGroup: UntypedFormGroup): void => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    if (matchingControl.errors && !matchingControl.errors.confirmedValidator) {
      return;
    }
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ confirmedValidator: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}
